export default "<div ng-if=\"$ctrl.show\" ng-transclude></div>"